import { useEffect } from 'react'
import { X } from 'lucide-react'

export default function SlideUpPanel({ 
  isOpen, 
  onClose, 
  title, 
  children,
  showHeader = true,
  fullHeight = false 
}) {
  // Blocca scroll body quando aperto
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
    return () => {
      document.body.style.overflow = ''
    }
  }, [isOpen])

  // Chiudi con ESC
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') onClose()
    }
    if (isOpen) {
      window.addEventListener('keydown', handleEsc)
    }
    return () => window.removeEventListener('keydown', handleEsc)
  }, [isOpen, onClose])

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 lg:flex lg:items-center lg:justify-center">
      {/* Overlay */}
      <div 
        className="absolute inset-0 bg-black/50 transition-opacity"
        onClick={onClose}
      />
      
      {/* Panel */}
      <div className={`
        absolute bottom-0 left-0 right-0 
        lg:relative lg:bottom-auto lg:left-auto lg:right-auto
        lg:w-full lg:max-w-2xl lg:mx-4
        bg-white dark:bg-gray-800 
        rounded-t-2xl lg:rounded-2xl
        shadow-xl
        animate-slide-up
        flex flex-col
        ${fullHeight ? 'h-[95vh] lg:h-auto lg:max-h-[90vh]' : 'max-h-[90vh] lg:max-h-[85vh]'}
      `}>
        {/* Header */}
        {showHeader && (
          <div className="flex items-center justify-between p-4 border-b border-gray-200 dark:border-gray-700 flex-shrink-0">
            <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
              {title}
            </h2>
            <button
              onClick={onClose}
              className="p-2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors"
            >
              <X className="h-5 w-5" />
            </button>
          </div>
        )}
        
        {/* Content */}
        <div className="flex-1 overflow-y-auto">
          {children}
        </div>
      </div>
    </div>
  )
}
